import styled from 'styled-components';

import { Card } from '../../../../../../ToolkitV2/CardV2/Card';
import { SkeletonBlock } from '../../../../../../ToolkitV2/Skeleton/Skeleton';

import { media } from '../../../../../../../helpers/breakpoints';

export const CARD_HEIGHT_PX = 88;
export const IMAGE_WIDTH_PX = 117;

const CARD_HEIGHT = `${CARD_HEIGHT_PX}px`;
const IMAGE_WIDTH = `${IMAGE_WIDTH_PX}px`;

const StyledAdCard = styled(Card)`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  overflow: hidden;
  height: ${CARD_HEIGHT};
`;

const AdCardImage = styled.img`
  width: ${IMAGE_WIDTH};
  max-width: ${IMAGE_WIDTH};
  height: ${CARD_HEIGHT};
  object-fit: cover;
  object-position: 50% 50%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`;

const FallbackImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${IMAGE_WIDTH};
  height: ${CARD_HEIGHT};
  background-color: ${({ theme }) => theme.colors.GREY_LIGHTER};
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  ${media.medium} {
    width: ${IMAGE_WIDTH};
  }
`;

const ImageSkeleton = styled(SkeletonBlock)`
  border-radius: 0;
`;

export { StyledAdCard, AdCardImage, FallbackImageContainer, ImageSkeleton };
